import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/out_org_zly.jpg'


const _withScopeId = n => (_pushScopeId("data-v-689b7ee0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "approve_index" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "项目信息", -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "项目编号：", -1))
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "项目名称：", -1))
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "担保金额：", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "企业名称：", -1))
const _hoisted_15 = { class: "value" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "出函机构", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "经办人信息", -1))
const _hoisted_19 = { class: "content" }
const _hoisted_20 = { class: "item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"35px"} }, "经办人姓名：", -1))
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"35px"} }, "经办人手机号码：", -1))
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { class: "content top" }
const _hoisted_27 = { class: "money" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("提交订单")
const _hoisted_29 = {
  class: "van-coupon-list__list van-coupon-list__list--with-bottom",
  style: {"height":"488px"}
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "van-coupon__content" }
const _hoisted_32 = { class: "van-coupon__head" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "van-coupon__amount" }, [
  /*#__PURE__*/_createTextVNode("1.5"),
  /*#__PURE__*/_createElementVNode("span", null, "元")
], -1))
const _hoisted_34 = { class: "van-coupon__condition" }
const _hoisted_35 = { class: "van-coupon__body" }
const _hoisted_36 = { class: "van-coupon__name" }
const _hoisted_37 = { class: "van-coupon__valid" }
const _hoisted_38 = {
  role: "checkbox",
  class: "van-checkbox van-coupon__corner",
  tabindex: "0",
  "aria-checked": "false"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "van-badge__wrapper van-icon van-icon-success" }, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { class: "van-coupon__description" }
const _hoisted_42 = {
  class: "van-coupon-list__list van-coupon-list__list--with-bottom",
  style: {"height":"488px"}
}
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "van-coupon__content" }
const _hoisted_45 = { class: "van-coupon__head" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "van-coupon__amount" }, [
  /*#__PURE__*/_createTextVNode("1.5"),
  /*#__PURE__*/_createElementVNode("span", null, "元")
], -1))
const _hoisted_47 = { class: "van-coupon__condition" }
const _hoisted_48 = { class: "van-coupon__body" }
const _hoisted_49 = { class: "van-coupon__name" }
const _hoisted_50 = { class: "van-coupon__valid" }
const _hoisted_51 = {
  role: "checkbox",
  class: "van-checkbox van-coupon__corner",
  tabindex: "0",
  "aria-checked": "false"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "van-badge__wrapper van-icon van-icon-success" }, null, -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = { class: "van-coupon__description" }
const _hoisted_55 = { class: "van-coupon-list__bottom" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode("不使用优惠券")
const _hoisted_57 = {
  key: 0,
  class: "loading"
}
const _hoisted_58 = /*#__PURE__*/_createTextVNode("加载中...")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_loading = _resolveComponent("van-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.saleNo), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.regist.biaodi_name), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.toMoney(_ctx.regist.letter_money / 10000)) + "万元", 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.regist.bider_name), 1)
      ])
    ]),
    _hoisted_16,
    _hoisted_17,
    _hoisted_18,
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.regist.person_name), 1)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.regist.person_mobile), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.regist.money_pay), 1),
      _createVNode(_component_van_button, {
        class: "submit",
        type: "danger",
        size: "small",
        onClick: _ctx.RegistConfirm
      }, {
        default: _withCtx(() => [
          _hoisted_28
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.couponsList,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.couponsList) = $event)),
      round: "",
      position: "bottom",
      style: {"height":"85%","padding-top":"4px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tabs, {
          active: _ctx.active,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.active) = $event)),
          style: {"background":"#f7f8fa"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_tab, { title: "可用" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coupons, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "van-coupon",
                      key: item.id
                    }, [
                      (item.status == 1)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.ckcoupon(item))
                          }, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _hoisted_33,
                                _createElementVNode("p", _hoisted_34, _toDisplayString(item.coupon_condition), 1)
                              ]),
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("p", _hoisted_36, _toDisplayString(item.coupon_type_name), 1),
                                _createElementVNode("p", _hoisted_37, "有效期至： " + _toDisplayString(item.effective_end), 1),
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["van-checkbox__icon van-checkbox__icon--round", {'van-checkbox__icon--checked': _ctx.couponId == item.id}])
                                  }, _hoisted_40, 2)
                                ])
                              ])
                            ]),
                            _createElementVNode("p", _hoisted_41, _toDisplayString(item.super == 1 ? '专属券': '平台券'), 1)
                          ], 8, _hoisted_30))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_tab, { title: "不可用" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_42, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coupons, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "van-coupon",
                      key: item.id
                    }, [
                      (item.status == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("div", _hoisted_45, [
                                _hoisted_46,
                                _createElementVNode("p", _hoisted_47, _toDisplayString(item.coupon_condition), 1)
                              ]),
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("p", _hoisted_49, _toDisplayString(item.coupon_type_name), 1),
                                _createElementVNode("p", _hoisted_50, "有效期至： " + _toDisplayString(item.effective_end), 1),
                                _createElementVNode("div", _hoisted_51, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["van-checkbox__icon van-checkbox__icon--round", {'van-checkbox__icon--checked': _ctx.couponId == item.id}])
                                  }, _hoisted_53, 2)
                                ])
                              ])
                            ]),
                            _createElementVNode("p", _hoisted_54, _toDisplayString(item.super == 1 ? '专属券': '平台券'), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["active"]),
        _createElementVNode("div", _hoisted_55, [
          _createVNode(_component_van_button, {
            type: "danger",
            class: "van-button--block van-button--round",
            onClick: _ctx.disCkcoupon
          }, {
            default: _withCtx(() => [
              _hoisted_56
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
          _createVNode(_component_van_loading, {
            size: "24px",
            vertical: "",
            color: "#0094ff"
          }, {
            default: _withCtx(() => [
              _hoisted_58
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}